import { Box, styled } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

export const HeaderWrapper = styled(Box)({
  display: "flex",
  //   height: "120px",
  color: "#fff",
  backgroundColor: colors.primaryBlue,
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: "10px 30px 10px 30px",
})

export const HeaderLeft = styled(Box)({
  display: "flex",
  flexDirection: "column",
})

export const HeaderCenter = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  flexGrow: 0.6,
})
